import {Inputs, WithoutNullables} from '../types';

const Defaults: Partial<WithoutNullables<Inputs>> = {
  plantingYear: new Date().getMonth() <= 3 ? new Date().getFullYear() : new Date().getFullYear() + 1,
};

export default Defaults;
